import React from 'react';
import { motion } from 'framer-motion';
import { Icon } from '@fuxi/eevee-icon';
import { useSelector } from 'react-redux';
import doubleCircleImg from '@/assets/image/double-circle.svg';
import { selectedCurrentCustomer } from '@/store/customer';
import { storagePrefixV2 } from '@/constant';
import { DIMENTION_2_TEXT, MODEL_CARD_CONFIG } from '../../utils';
import InfoCard from '../info-card';
import { setShowType, useWeightLossStore } from '../useWeightLossStore';

import cx from './index.module.scss';

interface Props {}

const ShowLeftCalf: React.FC<Props> = () => {
  const showType = useWeightLossStore.use.showType();
  const currentCustomer = useSelector(selectedCurrentCustomer);

  return (
    <motion.div className={cx('ShowLeftCalf')}>
      <motion.div
        className="info-card"
        transition={{ duration: 0.2 }}
        initial={{ top: '25%', opacity: 0 }}
        animate={{ top: '15%', opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <InfoCard />
      </motion.div>
      <motion.div className={cx('connection-line')} exit={{ display: 'none', transition: { duration: 0 } }} />
      <motion.div
        style={
          currentCustomer?.gender === 'Male'
            ? {
                backgroundImage: `url(${storagePrefixV2}/ai-consulation/male-model-bg/part/safgbxc.png)`,
              }
            : {}
        }
        className={cx('model-wrapper')}
        transition={{ duration: 0.3 }}
        initial={{ right: '-4%', opacity: 0.2 }}
        animate={{ right: '2%', opacity: 1 }}
        exit={{ right: '5%', opacity: 0 }}
      />
      <motion.div
        className={cx('animation-wrapper', currentCustomer?.gender)}
        transition={{ duration: 0, delay: 0.5 }}
        initial={{ visibility: 'hidden' }}
        animate={{ visibility: 'visible' }}
        exit={{ display: 'none', transition: { duration: 0 } }}
      >
        <motion.div
          className="motion-item"
          transition={{ duration: 1.3, ease: 'easeInOut', repeat: Infinity, repeatType: 'loop', repeatDelay: 1 }}
          animate={{ scale: [1, 0.8, 0.8], opacity: [1, 1, 0] }}
        />
        <motion.div
          className="motion-item"
          transition={{
            duration: 1.3,
            delay: 0.2,
            ease: 'easeInOut',
            repeat: Infinity,
            repeatType: 'loop',
            repeatDelay: 1,
          }}
          animate={{ scale: [1, 0.8, 0.8], opacity: [1, 1, 0] }}
        />
        <motion.div
          className="motion-item"
          transition={{
            duration: 1.3,
            delay: 0.4,
            ease: 'easeInOut',
            repeat: Infinity,
            repeatType: 'loop',
            repeatDelay: 1,
          }}
          animate={{ scale: [1, 0.8, 0.8], opacity: [1, 1, 0] }}
          exit={{ display: 'none', transition: { duration: 0 } }}
        />
      </motion.div>
      <motion.div
        className={cx('part-wrapper')}
        transition={{ duration: 0.5 }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ display: 'none', transition: { duration: 0 } }}
      >
        {MODEL_CARD_CONFIG.map(item => (
          <div
            className={cx('part-card', item.name, { current: item.name === showType })}
            onClick={() => setShowType(item.name)}
            key={item.name}
          >
            {item.name === showType && <img src={doubleCircleImg} className="double-circle-img" />}
            <div className="part-name">{DIMENTION_2_TEXT[item.name]}</div>
            {item.name !== showType && <Icon name="arrow-right" />}
          </div>
        ))}
      </motion.div>
    </motion.div>
  );
};

export default ShowLeftCalf;
